module.exports = __webpack_public_path__ + "img/buka.caebf1b3.png";